<template>
  <BaseListItem>
    <div class="flex -mx-3 py-1">
      <div class="flex-1 px-3">
        <template v-if="contact">
          <p>{{ fullName }}</p>
          <p class="text-sm font-medium text-gray-600 tracking-wide">
            <a :href="`mailto:${contact.email}`">{{ contact.email }}</a>
            &bull;

            <a v-if="hasValidPhoneFormat" :href="`tel:+30${contact.phone}`">{{ contact.phone }} </a>
            <span v-else>{{ contact.phone }}</span>
          </p>
        </template>
        <span v-else class="text-red-600">missing contact</span>
      </div>

      <div class="w-24 px-3 text-right">
        <span
          :class="{
            'inline-block': true,
            'bg-green-200': subscription.active,
            'bg-red-200': !subscription.active,
            'px-3': true,
            'py-1': true,
            'leading-snug': true,
            rounded: true,
            'text-xs': true,
            'text-green-600': subscription.active,
            'text-red-600': !subscription.active,
            capitalize: true,
            'font-medium': true,
            'select-none': true,
          }"
        >
          {{ subscription.active ? 'active' : 'inactive' }}
        </span>
      </div>

      <div class="w-48 px-3 text-right text-sm">
        {{ subscription.createdAtDiffForHumans }}
      </div>
    </div>
  </BaseListItem>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    subscription: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('entities', {
      contact(state) {
        return state.contacts.byId[this.subscription.contactId] || null;
      },
    }),
    fullName() {
      if (!this.contact) return 'contact does not exist';
      return `${this.contact.firstName} ${this.contact.lastName}`;
    },
    hasValidPhoneFormat() {
      if (!this.contact || !this.contact.phone) return false;
      return /^\d{10}$/.test(this.contact.phone);
    },
  },
};
</script>
